export default __webpack_public_path__ + "static/media/flag.747b050b.svg";